import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatSort, MatPaginator, MatDialog, MatDialogConfig } from '@angular/material';
import { FaqService } from 'src/app/shared/services/faq.service';
//import { ToastrService } from 'ngx-toastr';
import { FaQModel } from 'src/app/shared/models/faq.model';
import { FaqEditComponent } from '../faq-edit/faq-edit.component';
import { Router } from '@angular/router';
import { UserService } from 'src/app/shared/services/user.service';
import { GlobalNotification} from "src/app/shared/constants/global-notification";

@Component({
  selector: 'app-faq-list',
  templateUrl: './faq-list.component.html',
  styleUrls: ['./faq-list.component.css']
})
export class FaqListComponent implements OnInit {

  thisData : MatTableDataSource<any>;
  displayColumn : string[]= ['issue/solution',  'actions'];
  @ViewChild(MatSort, { static: false }) sort : MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator : MatPaginator;
  searchKey : string;
  dialogConfig = new MatDialogConfig();

  constructor(
    private userService : UserService,
    private router : Router,
    private service : FaqService,
   // private toastr : ToastrService,
    private gnotify : GlobalNotification,
    private dialog : MatDialog) {

      this.dialogConfig.disableClose = true;
      this.dialogConfig.autoFocus = true;
      this.dialogConfig.width = "60%";

    }

  ngOnInit() {
    this.refreshList();
  }
  populateForm(item : FaQModel){
    this.service.formData  = Object.assign({}, item);
  }

  onDelete(id)
  {
    console.log("onDelete : " + id);

    if(!confirm("Are you sure to delete this FaQ?")) return;

    this.service.deleteData(id).subscribe(
      res=>{
        ////this.toastr.warning("Submitted successfully", "FaQ Delete");
        this.gnotify.showSnackBar('FaQ Delete', 'Submitted successfully', "error");
        this.searchKey = "";
        this.refreshList();
      },
      err=>{
        console.log(err);
      }
    );
  }

  refreshList()
  {
    this.service.getList().subscribe(
      res => {
        let array = res as FaQModel[];
        this.thisData = new MatTableDataSource(array);
        this.thisData.sort = this.sort;
        this.thisData.paginator = this.paginator;
        console.log("refreshList : " + this.thisData.data.length);
        this.applyFilter();
       },
       err =>{
         console.log(err);
       }
    );

  }

  onSearchClear()
  {
    this.searchKey = "";
    this.applyFilter();
  }

  applyFilter()
  {
    if(this.searchKey != null) this.thisData.filter = this.searchKey.trim().toLowerCase();
  }

  onCreate()
  {
    //this.service.initializeFormGroup();

    this.dialogConfig.data = {
      id : null,
      result : false
    };
    let dialogRef = this.dialog.open(FaqEditComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {

      if(this.dialogConfig.data.result)
      {
        console.log(true);
        this.refreshList();

      }
      else{
        console.log(false);
      }
    });

  }

  onDetail(id){
    this.router.navigateByUrl('/faq-detail/' + id);
  }


}
